/* src/components/MainContent.jsx - Última Modificación: 26-02-2026 */
/* ---------------------------------------------------------------- */

import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Box } from '@mui/material';

import { routesConfig } from '../config/routesConfig.js';
import RequireRole from './RequireRole.jsx';
import Breadcrumbs from './Breadcrumbs';

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -6 },
};

const pageTransition = {
  duration: 0.18,
  ease: 'easeInOut',
};

const MainContent = ({ onMenuSelect }) => {
  const location = useLocation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        overflow: "hidden",
        pt: "64px", // 👈 altura del Navbar
      }}
    >
      {/* Breadcrumb */}
      <Box px={2} pt={1} flexShrink={0}>
        <Breadcrumbs />
      </Box>

      {/* Contenido */}
      <Box
        flex={1}
        overflow="auto"
        px={2}
        pt={2}
        pb={3}
        minHeight={0}
      >
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            {routesConfig.map(({ path, element: Component, roles }) => (
              <Route
                key={path}
                path={path}
                element={
                  <RequireRole roles={roles}>
                    <motion.div
                      variants={pageVariants}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      transition={pageTransition}
                      style={{ height: '100%' }}
                    >
                      <Component onMenuSelect={onMenuSelect} />
                    </motion.div>
                  </RequireRole>
                }
              />
            ))}

            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </AnimatePresence>
      </Box>
    </Box>
  );
};

export default MainContent;
